import React from 'react';
import './style.scss';
type SvgIconProps = {
  aditionalClass?: string;
  source: string;
  name?: string;
  height: number;
  width: number;
};

const SvgIcon: React.FC<SvgIconProps> = ({
  aditionalClass = '',
  source = '',
  name = 'default-name-svg-icon',
  height = undefined,
  width = undefined,
}) => {
  return (
    <div className={`${aditionalClass || ''}`}>
      <span role='img' aria-label={name} className='svg-icon-subcontainer'>
        <img src={source} alt={name} title={name} height={height} width={width} />
      </span>
    </div>
  );
};

export default SvgIcon;
